export class DiceResult {
    public diceNum = 0;
    public diceSize = 0;
    public desc = '';
    public rolls: Array<number> = [];
    public bonus = 0;
    public included = true;
    public type = '';
}
